export const environment = {
	apiUrl: 'https://dti-gateway-dev.azure-api.net/dev/v1',
	reportsApiUrl: 'https://dti-reports-af-dev.azurewebsites.net/api',
	coreMonitorUrl: 'https://dti-core-monitor-af-dev.azurewebsites.net/api',
	coreTraderUrl: 'https://dti-core-trader-af-dev.azurewebsites.net/api',
	coreConfigUrl: 'https://dti-core-config-af-dev.azurewebsites.net/api',
	coreNotifyUrl: 'https://dti-core-notify-af-dev.azurewebsites.net/api',
	isMocksEnabled: false,
	priceRefreshTimeSeconds: 15,
	auth: {
		clientId: '629087b8-7bbc-42e4-ae5e-5f7c56fce528',
		redirectUri: 'https://dev.demeter-funds.com',
		method: 'redirect' as 'redirect' | 'popup'
	},
	overrideIsAfterClose: false,
	mwrEnabled: false,
	dataQualityEnabled: true,
	demeterEnv: 'dev'
};
